import { useState } from 'react';
import { JFormik } from '@centerpiece/components';
import { toast } from 'react-toastify';
import {
  useCreateSubscriberMutation,
  useGetSubscriberQuery,
  useGetTeamsQuery,
  useUpdateSubscriberMutation,
} from 'store/api';
import { Contact, Subscriber, Team } from 'store/api/models';
import { useContactForm } from 'jformik/useContactForm';
import { Box, Button, Typography } from '@mui/material';
import { ArrowBack, Edit } from '@mui/icons-material';

export interface AccountComponentProps {
  open: boolean;
  close: Function;
  disabled?: boolean;
  id?: number;
  category?: string;
}

export const AccountComponent = ({
  open,
  close,
  disabled = false,
  id,
}: AccountComponentProps) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(disabled);
  const form = useContactForm({ edit: !!id, role: true, account: true });
  const { data: scontact = {} as Subscriber, isLoading } =
    useGetSubscriberQuery(
      { id: id || 0, params: { nested: 'all' } },
      { skip: !id }
    );
  const { data: teams = [] as Team[], isLoading: teamsLoading } =
    useGetTeamsQuery({});
  const [createSubscriber] = useCreateSubscriberMutation();
  const [updateSubscriber] = useUpdateSubscriberMutation();
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2,
        }}
      >
        <Button
          startIcon={<ArrowBack />}
          color="secondary"
          onClick={() => close()}
        >
          <Typography
            sx={{
              lineHeight: 1,
              marginTop: 0.25,
              fontSize: 15,
            }}
          >
            Back
          </Typography>
        </Button>
        {isDisabled && (
          <Button
            startIcon={<Edit />}
            color="secondary"
            onClick={() => setIsDisabled(false)}
          >
            <Typography
              sx={{
                lineHeight: 1,
                marginTop: 0.25,
                fontSize: 15,
              }}
            >
              Edit
            </Typography>
          </Button>
        )}
      </Box>
      <Box sx={{ marginTop: 0, px: 1 }}>
        <JFormik
          loading={isLoading || teamsLoading}
          disabled={isDisabled}
          initialValues={() => ({
            ...(scontact.contact_r || {}),
            name: `${scontact.contact_r?.firstname} ${scontact.contact_r?.lastname}`,
            form: {
              ...(scontact.contact_r?.form || {}),
              team: teams.find(
                (t: Team) => t.id == scontact.contact_r?.form?.team?.id
              ),
            },
            role: scontact.role_r,
            id: id,
          })}
          handleSubmit={async (values, formik) => {
            if (id) {
              try {
                const newTemplate = await updateSubscriber({
                  ...values,
                  role: values?.role?.id,
                  id: id,
                }).unwrap();
                close();
                toast.info('Account updated successfuly');
              } catch (error) {
                toast.error('Unable to update account');
              }
            } else {
              try {
                const newTemplate = await createSubscriber({
                  ...values,
                  role: values?.role?.id,
                }).unwrap();
                close();
                toast.info('Account created successfuly');
              } catch (error) {
                toast.error('Unable to create account');
              }
            }
          }}
          validationSchema={form.validationSchema}
          form={form.form}
        />
      </Box>
    </Box>
  );
};
